import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsPage.RequestReportsListPage.ReportCard', {
    unnamedReport: 'Unnamed report',
    filterPreviewTextAll: 'All requests',
    reportTileFilterEllipsisText: '...',
});
